import { topicsList } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-medium mb-4 whitespace-nowrap">
            <i className="ri-hashtag"></i>
            话题广场
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            热门话题标签
          </h2>
          <p className="text-sm text-foreground-500 mt-2">点击话题直达相关资讯</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 max-w-[1000px] mx-auto">
          {topicsList.map((topic, idx) => (
            <a
              key={idx}
              href="#ranking"
              onClick={(e) => {
                e.preventDefault();
                const el = document.querySelector('#ranking');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }}
              className={`whitespace-nowrap group inline-flex items-center gap-2 px-4 py-2.5 rounded-full border cursor-pointer transition-all ${
                topic.color === 'primary'
                  ? 'bg-primary-50 border-primary-200 text-primary-800 hover:bg-primary-100'
                  : 'bg-accent-50 border-accent-200 text-accent-800 hover:bg-accent-100'
              }`}
            >
              <span className="text-sm font-medium">{topic.name}</span>
              <span className="text-xs opacity-60">{topic.heat}</span>
              <i className="ri-arrow-right-line text-xs opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all"></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}